import ForgotPasswordFormContainer from './ForgotPasswordFormContainer';

export default ForgotPasswordFormContainer;
